import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';




@Injectable()
export class ExportService {
  private _url = 'api/export';

  constructor(
    private _httpClient: HttpClient,
  ) { }

  public exportData(filters: any): Observable<Blob> {
    let params = new HttpParams();
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (Array.isArray(value)) {
        value.forEach((item: any) => {
          params = params.append(key, item);
        });
      } else if (value) {
        params = params.set(key, value);
      }
    });

    return this._httpClient.get<Blob>(this._url, { params, responseType: 'blob' as 'json' });
  }

}


